import { storage, tokenTableName, appIdTableName } from '@/config'
import cookie from 'js-cookie'

export function clearStorage() {
  if (storage) {
    if ('localStorage' === storage) {
      return localStorage.clear()
    } else if ('sessionStorage' === storage) {
      return sessionStorage.clear()
    } else if ('cookie' === storage) {
      return cookie.clear()
    } else {
      return localStorage.clear()
    }
  } else {
    return localStorage.clear()
  }
}

export function clearSessionStorage() {
  sessionStorage.clear()
}

/**
 * @description 获取token
 * @returns {string|ActiveX.IXMLDOMNode|Promise<any>|any|IDBRequest<any>|MediaKeyStatus|FormDataEntryValue|Function|Promise<Credential | null>}
 */
export function getToken() {
  if (storage) {
    if ('localStorage' === storage) {
      return localStorage.getItem(tokenTableName)
    } else if ('sessionStorage' === storage) {
      return sessionStorage.getItem(tokenTableName)
    } else if ('cookie' === storage) {
      return cookie.get(tokenTableName)
    } else {
      return localStorage.getItem(tokenTableName)
    }
  } else {
    return localStorage.getItem(tokenTableName)
  }
}

export function getAppId() {
  if (storage) {
    if ('localStorage' === storage) {
      return localStorage.getItem(appIdTableName)
    } else if ('sessionStorage' === storage) {
      return sessionStorage.getItem(appIdTableName)
    } else if ('cookie' === storage) {
      return cookie.get(appIdTableName)
    } else {
      return localStorage.getItem(appIdTableName)
    }
  } else {
    return localStorage.getItem(appIdTableName)
  }
}

/**
 * @description 存储token
 * @param token
 * @returns {void|*}
 */
export function setToken(token) {
  if (storage) {
    if ('localStorage' === storage) {
      return localStorage.setItem(tokenTableName, token)
    } else if ('sessionStorage' === storage) {
      return sessionStorage.setItem(tokenTableName, token)
    } else if ('cookie' === storage) {
      return cookie.set(tokenTableName, token)
    } else {
      return localStorage.setItem(tokenTableName, token)
    }
  } else {
    return localStorage.setItem(tokenTableName, token)
  }
}

export function setAppId(appid) {
  if (storage) {
    if ('localStorage' === storage) {
      return localStorage.setItem(appIdTableName, appid)
    } else if ('sessionStorage' === storage) {
      return sessionStorage.setItem(appIdTableName, appid)
    } else if ('cookie' === storage) {
      return cookie.set(appIdTableName, appid)
    } else {
      return localStorage.setItem(appIdTableName, appid)
    }
  } else {
    return localStorage.setItem(appIdTableName, appid)
  }
}

/**
 * @description 移除token
 * @returns {void|Promise<void>}
 */
export function removeToken() {
  if (storage) {
    if ('localStorage' === storage) {
      return localStorage.removeItem(tokenTableName)
    } else if ('sessionStorage' === storage) {
      return sessionStorage.clear()
    } else if ('cookie' === storage) {
      return cookie.remove(tokenTableName)
    } else {
      return localStorage.removeItem(tokenTableName)
    }
  } else {
    return localStorage.removeItem(tokenTableName)
  }
}
